import { Outlet } from "react-router-dom"
const MainAllTask = () =>{

    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}


export default MainAllTask;